import { create } from 'zustand';

export const useExerciseImprovementActionsStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    uniqueValues: {},

    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
    setPagination: (pagination) => set((state) => ({
        pagination: { ...state.pagination, ...pagination }
    }))
}));
